const routesNotShowingToast = [
  "/api/slpapp/BlockToFloor",
  "api/public/slpapp/BlockToFloor",
  "/api/slpapp/Report/getFaultReport",
  "/api/slpapp/Report/getBurnTimeReport",
  "/api/slpapp/Report/getMotionTrafficReport",
  "/api/slpapp/Report/getMotionHeatMapReport",
  "/api/slpapp/Report/getEnergyReport",
  "/api/slpapp/Report/getTestReport",
  "/api/slpapp/Report/getUserActivityReport",
  "/api/slpapp/Report/getEnvironmentalReport",
  "/api/slpapp/DaylightProfile/SetDaylightProfile",
  "/api/slpapp/RainProfile/SetRainProfile",
  "/api/slpapp/DaylightHarvestingProfile/SetDaylight",
  "/slpapp/LightParameter/SetLightIntensity",
  "/slpapp/LightParameter/SetLightingOverride",
  "/slpapp/LightParameter/SetSoftDimming",
  "/slpapp/LightParameter/SetTimeDelay",
  "/slpapp/GetCommand/SendGetCommandToDms",
  "/slpapp/SensorParameter/SetMotionSensor",
  "/slpapp/SensorParameter/SetPhotoSensor",
  "/slpapp/GatewayZone/SaveCommandToGatewayByAssetCode",
];

export const isToastUnavailableRoute = (responseUrl: string) => {
  return routesNotShowingToast.some((route) => {
    const index = responseUrl.indexOf(route);
    if (index === -1) return false;
    const nextChar = responseUrl[index + route.length];
    return nextChar === undefined || nextChar === "?" || nextChar === "/";
  });
};
